import { useEffect, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { matchPath } from 'react-router';
import { useSelector } from 'react-redux';
import routes from '../routes';

export const useUserAccess = () => {
  const [userAccess, setUserAccess] = useState({});
  const location = useLocation();
  const navigate = useNavigate();
  const authorizationSubMenuList = useSelector(state => state.admin.authorizationSubMenuList);

  // Determine current route
  const currentRoute = routes.find(route =>
    matchPath(route.path, location.pathname)
  );

  useEffect(() => {
    if (currentRoute) {
      const user_access = authorizationSubMenuList && authorizationSubMenuList.find(
        item => item.name === currentRoute.group
      );
      console.log({currentRoute})
       console.log({authorizationSubMenuList})
      console.log({user_access})
      localStorage.setItem('menu_id', user_access?.menu_id);
      setUserAccess(user_access || {}); // Avoid setting undefined
    }
  }, [currentRoute, authorizationSubMenuList]);

  useEffect(() => {
    if (userAccess && !userAccess.act_checkbox) {
      //navigate('/Oops');
    }
  }, [userAccess, navigate]); // Added navigate as a dependency for best practice  

  return userAccess;
};
